import gql from 'graphql-tag'

export const GET_SOCIAL_LINK_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getSocialLinkPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
        title
      }
    }
  }
`

export const GET_SOCIAL_LINK_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getSocialLink (
      data: {
        id: $id
      }
    ) {
      id
      icon
      title
      url
    }
  }
`
